import React from "react";
import { Font } from "pepsico-ds";
type UserDataProps = {
  title: string;
  description: string | React.ReactNode;
};
function UserData(props: UserDataProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
      <Font size="small" style={{ color: "var(--gray-400)" }} variant={"bold"}>
        {props.title}
      </Font>
      {typeof props.description === "string" ? (
        <Font size="small">{props.description}</Font>
      ) : (
        props.description
      )}
    </div>
  );
}

export default UserData;
